import { FC } from 'react';
import classNames from 'classnames';
import styles from './bar-icon-wrapper.module.scss';

const BarIconWrapper: FC<{ className?: string }> = ({ children, className }) => {
  return <div className={classNames(styles.root, className)}>{children}</div>;
};

export default BarIconWrapper;
